import { observer } from "mobx-react";
import { useStores } from "../../../../../../../stores";
import { GLV_Container, groupLessonViewVariants } from "./GroupLessonView.styled";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { GroupLessonItem } from "./GroupLessonItem";
import { getGrandChartRoute } from "../../../../../../../helpers/grandChart/grandChart.helper";
import { useEffect, useRef } from "react";

interface GroupLessonViewProps {}

export const GroupLessonView = observer(({}: GroupLessonViewProps) => {
	const { grandCharts } = useStores();
	const { selected } = grandCharts;

	const navigate = useNavigate();
	const location = useLocation();

	const selectedGroupRef = useRef<HTMLDivElement | null>(null);

	const { courseId, moduleId, groupId } = useParams<{
		courseId: string;
		moduleId: string;
		groupId: string;
	}>();

	const keyFindGroupLessons = `${courseId}-${moduleId}`;

	const groupsLesson = selected.group_lessons_map[`${keyFindGroupLessons}`] || [];

	useEffect(() => {
		if (!groupId || !selectedGroupRef.current) {
			return;
		}
		const timer = window.setTimeout(() => {
			selectedGroupRef.current?.scrollIntoView({
				behavior: "smooth",
				block: "start",
			});
		}, 500);
		return () => window.clearTimeout(timer);
	}, [groupId, groupsLesson.length]);

	const handleOnBack = () => {
		navigate(getGrandChartRoute(location.pathname, selected.id), {
			replace: true,
		});
	};

	return (
		<GLV_Container variants={groupLessonViewVariants} initial="hidden" animate="visible" exit="exit">
			{groupsLesson.map((groupLesson, index) => {
				const isFirst = index === 0;
				const isSelected = Number(groupId) === groupLesson.id;

				return (
					<GroupLessonItem
						ref={isSelected ? selectedGroupRef : undefined}
						key={groupLesson.id}
						isFirstGroupLesson={isFirst}
						isShowBackButton={isFirst}
						isSelected={isSelected}
						service={selected.service.slug}
						groupLessonStore={groupLesson}
						onBackToGrandChart={handleOnBack}
					/>
				);
			})}
		</GLV_Container>
	);
});
